import themeGet from '@styled-system/theme-get';
import React from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex/Flex';
import { Step } from '../Step/Step';
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Stepper__StyledFlex",
  componentId: "sc-1ibf3q4-0"
})(["& > :not(:last-child){margin-right:", "px;}"], themeGet('space.4'));
/**
 * @public
 */
export function Stepper({
  className,
  children,
  ...props
}) {
  return React.createElement(StyledFlex, {
    className: className,
    ...props
  }, children);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Stepper.Step = Step;